/**
 * WHAT: Privacy / legal page bootstrap
 * WHY: Align CONFIG with other public pages that load script.js
 * HOW: Full-page background rotation uses body class `privacy` + Gallery admin → Site Background Images → Privacy & data tab
 */

import CONFIG from './config/config.js';

window.CONFIG = {
    api: CONFIG.api,
    features: CONFIG.features
};
